import { Component } from 'react';
import PropTypes from 'prop-types';

import css from 'styles/components/reviews/reviewSearch.scss';
import SearchField from 'components/common/SearchField';

export default class ReviewSearch extends Component {
  // empty string is a valid value if user is clearing search, so initial state must be explicit null
  state = { value: null }

  onChange = e => {
    const { value } = e.target;
    this.setState({ value });
  }

  onSubmit = e => {
    this.props.searchReviews(e, this.state.value === null ? this.props.initialValue : this.state.value);
  }

  render() {
    const {
      props: { initialValue },
      context: { testId },
      state: { value }, onChange, onSubmit
    } = this;
    return (
      <form
        method="get"
        className={css.form}
        role="search"
        aria-label="Review"
        onSubmit={onSubmit}
        data-test-id={testId('searchTermReviews')}>
        <SearchField
          name="searchTerm"
          id="reviewSearchField"
          type="search"
          placeholder="Search customer reviews"
          value={value !== null ? value : initialValue}
          onChange={onChange} />
        <label htmlFor="reviewSearchField" className="screenReadersOnly">Search Customer Reviews</label>
        <button type="submit" data-test-id={testId('searchReviewsButton')}>
          Search
        </button>
      </form>
    );
  }
}

ReviewSearch.propTypes = {
  isSearchingReviews: PropTypes.bool,
  searchReviews: PropTypes.func.isRequired,
  initialValue: PropTypes.string
};

ReviewSearch.contextTypes = {
  testId: PropTypes.func.isRequired
};
